import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const Fade = ({ hidden }) => {
  const duration = 200;

  const defaultStyle = {
    boxShadow: '0 -3em 3em -1em white inset',
    transition: `opacity ${duration}ms ease-out`,
    opacity: 0,
  };

  const transitionStyles = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
  };

  return (
    <Transition in={!hidden} timeout={duration}>
      {state => (
        <div
          className="bottom-0 left-0 right-0 top-0 absolute pointer-events-none"
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        />
      )}
    </Transition>
  );
};

Fade.propTypes = {
  hidden: PropTypes.bool,
};

Fade.defaultProps = {
  hidden: false,
};

export default Fade;
